var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "activity-stage"
  }, [_vm.currentRound.steps ? _c('div', {
    staticClass: "steps-container"
  }, [_vm._l(_vm.currentRound.steps, function (step) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: step.stepIndex === _vm.progress.stepIndex,
        expression: "step.stepIndex === progress.stepIndex"
      }],
      key: step.stepIndex,
      class: ['step-parent', step.stepIndex === _vm.progress.stepIndex ? 'step-parent-active' : '']
    }, [_c('div', {
      staticClass: "mychoice-instructions"
    }, [_vm._v("\n        " + _vm._s(step.instructions) + "\n      ")]), _c('div', {
      staticClass: "image-wrapper"
    }, [_c('img', {
      attrs: {
        "src": step.image
      }
    })]), _c('div', {
      staticClass: "question"
    }, [_vm._v(_vm._s(step.question))]), _c('div', {
      staticClass: "answer"
    }, [step.stepIndex === _vm.progress.stepIndex ? _c('answer-with-button', {
      attrs: {
        "done-callback": _vm.finishStep,
        "answer": step.answer,
        "is-big": step.type === 'paragraph' || step.type === 'sentence'
      }
    }) : _vm._e()], 1), _vm.showPlayAgain ? _c('div', {
      staticClass: "play-again",
      attrs: {
        "transition": "fade-05"
      },
      on: {
        "click": _vm.playAgain
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.playAgainButton,
        "alt": ""
      }
    }), _c('span', [_vm._v("Play Instructions Again")])]) : _vm._e()]);
  }), _vm.progress.stepIndex === _vm.currentRound.steps.length ? _c('div', {
    staticClass: "full-screen-row"
  }, [_vm.pdfPreviewSrc ? _c('div', {
    staticClass: "parent"
  }, [_c('iframe', {
    staticClass: "half-screen-column half-print",
    attrs: {
      "src": _vm.pdfPreviewSrc
    }
  }), _c('div', {
    staticClass: "container-buttons"
  }, [_c('button', {
    class: ['btn-common', _vm.showButtons ? 'btn-show' : ''],
    on: {
      "click": _vm.print
    }
  }, [_c('div', {
    staticClass: "action-button-content"
  }, [_vm._v("Print")])]), _c('button', {
    class: ['btn-common', _vm.showButtons ? 'btn-show' : ''],
    on: {
      "click": _vm.done
    }
  }, [_c('div', {
    staticClass: "action-button-content"
  }, [_vm._v("Done")])])])]) : _c('div', [_c('div', {
    staticClass: "spinner"
  })])]) : _vm._e()], 2) : _vm._e(), _vm.keyboardIsVisible ? _vm._t("keyboard") : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }